<template>
    <van-popup
            v-if="codeIdentificationPopupShow" v-model="codeIdentificationPopupShow" z-index="100" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '100vh',width: '100vw', background: '#fff' }"overlay-class="custom_popup"position="right">

        <div class="code_identification_wrap" >
            <div class="code_identification_top">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft" @click="handleClickClose">
                        <van-icon  name="arrow-left" />
                        <span class="normal_title">返回</span>
                    </div>
                </div>

                <div class="code_identification_tab">
                    <div class="code_identification_tab_wrap">
                        <span v-if="activeTabList.indexOf(1) > -1" @click="handleClickTab(1)" :class="{'active' : activeTab == 1}">已绑定产品识别码</span>
                        <span v-if="activeTabList.indexOf(2) > -1" @click="handleClickTab(2)" :class="{'active' : activeTab == 2}">未绑定产品识别码</span>
                        <span v-if="activeTabList.indexOf(3) > -1 && product_code_list.length>0" @click="handleClickTab(3)" :class="{'active' : activeTab == 3}">编码明细</span>
                    </div>
                </div>

                <div class="code_identification_nav">
                    <div class="code_identification_nav_wrap">
<!--                        <span v-if="activeNameList.indexOf(1) > -1 && activeTab == 1" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 1}" @click="handleClickNav(1)">编码识别</span>-->
                        <span v-if="activeNameList.indexOf(2) > -1 && activeTab == 2" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 2}" @click="handleClickNav(2)">人工输入绑定</span>
                        <span v-if="activeNameList.indexOf(3) > -1 && activeTab == 2" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 3}" @click="handleClickNav(3)">系统录入绑定</span>
                        <span v-if="activeNameList.indexOf(4) > -1 && activeTab == 2" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 4}" @click="handleClickNav(4)">人工输入+规则绑定</span>
<!--                        <span v-if="activeNameList.indexOf(5) > -1 && activeTab == 3" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 5}" @click="handleClickNav(5)">已选编码明细（{{product_code_list.length}}）</span>-->
                    </div>
                </div>


            </div>
            <div class="code_identification_content" :class="activeTab == 2 ? 'code_identification_content_wrap' : ''">
                <template v-if="activeName == 1">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span> <span class="del" @click="handleClickDel">清除</span></div>
                    </div>
                    <div class="bottom">
                        <template v-if="hasError == false">
                            <el-input @input="getCodeLength" class="input_textarea height_flex" placeholder="请输入产品编码
批量输入需换行
请注意输入格式数字与字母的组合，纯数字或纯英文，
特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”" ref="textareaValue" type="textarea"  v-model="textareaValue" ></el-input>
                        </template>
                        <template v-else>
                            <div class="error_code_wrap height_flex">
                                <ul>
                                    <li v-for="item in codeData" >
                                        <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                            <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                            <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                        </div>
                                        <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="activeName == 2">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span> <span class="del" @click="handleClickDel">清除</span></div>
                    </div>
                    <div class="bottom">
                        <template v-if="hasError == false">
                            <el-input @input="getCodeLength" class="height_flex" placeholder="请输入产品编码，批量生成需换行
请注意输入格式，推荐数字与字母的组合，纯数字或纯英文
特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”
组合示例：CP-12345678
                  cP-240918000001
数字示例：12345678
英文示例：abcdefghi
                  ABCDEFGHI
                  abcdEFGHI" ref="textareaValue" type="textarea"  v-model="textareaValue" ></el-input>

                        </template>
                        <template v-else>
                            <div class="error_code_wrap height_flex">
                                <ul>
                                    <li v-for="item in codeData" >
                                        <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                            <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                            <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                        </div>
                                        <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="activeName == 3">
                    <div class="set_generate_code_input">
                        <van-field label-width="68px"	 v-model="number" type="number" label="编码数量" required :min="0" :max="9999" placeholder="请输入需要生成的识别码数量">
                            <template #button>
                                <span class="line"></span>
                                <span class="template_color" @click="handleClickGenerateCode">生成编码</span>
                            </template>
                        </van-field>
                    </div>
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span></div>
                    </div>
                    <div class="bottom">
                        <div class="set_generate_code_wrap height_flex"  :class="codeData && codeData.length ? 'error_code_wrap' : ''">
                            <ul v-if="codeData && codeData.length">
                                <li v-for="item in codeData" >
                                    <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                        <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                        <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                    </div>
                                    <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                </li>
                            </ul>
                            <p v-else>输入数量过后，根据系统规则生成产品识别码。<br>示例：CP-2409180000000001</p>
                        </div>
                    </div>
                </template>
                <template v-if="activeName == 4">
                    <div class="set_generate_code_input borderRadio">
                        <van-field label-width="100px"	:formatter="ruleFormatter" v-model="rule" label="自定义规则" required  placeholder="请输入自定义规则，例abc1234">
                            <template #button>
                                <van-icon name="question" @click="handleClickQuestion" />
                            </template>
                        </van-field>
                    </div>

                    <div class="set_generate_code_input borderRadio">
                        <van-field label-width="68px"	 v-model="number" type="number" label="编码数量" required :min="0" :max="9999" placeholder="请输入需要生成的识别码数量">
                            <template #button>
                                <span class="line"></span>
                                <span class="template_color" @click="handleClickGenerateCode">生成编码</span>
                            </template>
                        </van-field>
                    </div>

                    <div class="top" style="margin-top: 12px">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span></div>
                    </div>
                    <div class="bottom">
                        <div class="set_generate_code_wrap  height_flex" :class="codeData && codeData.length ? 'error_code_wrap' : ''">
                            <ul v-if="codeData && codeData.length">
                                <li v-for="item in codeData" >
                                    <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                        <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                        <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                    </div>
                                    <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                </li>
                            </ul>
                            <div v-else>
                                <p>例：abc1234 </p>
                                <p style="text-indent: 2em">abc1235 </p>
                                <p style="text-indent: 2em">abc1236 </p>
                                <p style="text-indent: 2em">abc1237 </p>
                                <p style="text-indent: 2em">abc1238 </p>
                                <p style="text-indent: 2em">abc1239 </p>
                                <p style="text-indent: 2em">......</p>
                                <p style="text-indent: 2em">abc1250</p>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="activeName == 5">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{product_code_list.length}}条</span></div>
                    </div>
                    <div class="bottom">
                        <div class="set_generate_code_wrap error_code_wrap height_flex">
                            <ul v-if="product_code_list && product_code_list.length>0">
                                <li v-for="(item,key) in product_code_list" :key="key">
                                    <div class="code_input" >
                                        <el-input  readonly   size="small" :value="item"></el-input>
                                        <i  @click="handleClickDelSelectedCode(item,key)" class="el-icon-error"></i>
                                    </div>
                                </li>
                            </ul>
                            <p v-else class="ta_c">暂无内容</p>
                        </div>
                    </div>
                </template>
            </div>
            <div class="code_identification_footer">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
        </div>
    </van-popup>

</template>

<script>
import {generateProductCodes,generateCodes,codeCheck,identifyCodeOut,identifyCodeIn} from "@/api";
import { Dialog } from 'vant';
export default {
    name: "code_identification",
    props: {
        codeIdentificationPopupShow: {
            type: Boolean,
            default: false,
        },
        maxCodeIdentification:{
            type: [Number,Boolean],
            default: null
        },
        sourceType: {
            type: String,
            default: 'in'
        }, //来源 入库in  出库out
        productInfo: {
            type: Object,
            default: ()=>{}
        }, //产品  没有产品的话是点击的上面的编码识别，有产品id的话是选中产品后识别编码
        selectedCodeData: {
            type: Array,
            default: ()=> []
        }, //全部已选的产品编码
        related_info:{
            type: Object,
            default: ()=>{} //待办时的参数
        },
        relatedType: {
            type: String,
            default: ''
        },
        relatedId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: false,
            BtnDisabled:false,
            codeData:[],
            activeTab:1,
            oldActiveTab:1,
            activeName:1,
            hasError:false,
            textareaValue:'' , //批量输入的文本
            rule:'',//自定义的规则
            number:null, //生成编码的数量
            activeNameList:[],
            activeTabList:[],
            product_code_list:[]
        };
    },
    created() {
        if(this.sourceType == 'in'){
            if(this.productInfo){
                this.activeTab = 1
                this.activeTabList = [1,2,3]
                this.activeNameList = [2,3,4]
            }else{
                this.activeTabList = [1]
                this.activeNameList = [1]
            }
        }else if(this.sourceType == 'out'){
            this.activeTabList = [1,3]
            this.activeNameList = [1,5]
        }

        if(this.relatedType == 'purchase'){
            //采购入库
            this.activeTabList = [2,3]
            this.activeTab = 2
        }else if(this.relatedType.indexOf('order') > -1 && this.productInfo){
            this.activeTabList = [1,3]
            this.activeNameList = [2,3,4]
        }

        this.activeName = this.activeNameList[0]
        // 单独产品的已选编码
        if(this.productInfo && this.productInfo.code_list && this.productInfo.code_list.length > 0){
            this.product_code_list = JSON.parse(JSON.stringify(this.productInfo.code_list))
        }
    },
    methods: {
        ruleFormatter(value) {
            return value.replace(/[^a-zA-Z0-9\-\\()._~<>]+/g, '');
        },
        handleClickQuestion(){
            Dialog.alert({ title: '提示', message: '请输入自定义规则，规则为英文加数字，特殊符号只可输入-系统会根据所输入的规则中，包含的数字进行递增生成', })
            .then(() => {

            })
        },
        // 系统生成编码
        handleClickGenerateCode(){
            if( this.activeName == '3'){
                let postData = {
                    product_name: this.productInfo.name,
                    num: this.number,
                }
                this.loading = true
                generateProductCodes(postData).then(res => {
                    if(res.code == 200){
                        this.codeData = []
                        res.data.forEach((item,key)=>{
                            this.codeData.push({value:item,error:'',key:key})
                        })
                    }
                    this.loading = false
                })
            }else if( this.activeName == '4'){
                let postData = {
                    product_name: this.productInfo.name,
                    num: this.number,
                    rule: this.rule,
                }
                this.loading = true
                generateCodes(postData).then(res => {
                    if(res.code == 200){
                        this.codeData = []
                        res.data.forEach((item,key)=>{
                            this.codeData.push({value:item,error:'',key:key})
                        })
                    }
                    this.loading = false
                })
            }
        },
        // 输入时获取编码数量
        getCodeLength(){
            this.$nextTick(()=>{
                var textArea = this.$refs.textareaValue
                var lines = textArea.value.split('\n');
                lines = lines.filter(Boolean);
                this.codeData = []
                lines.forEach((item,key)=>{
                    this.codeData.push({value:item.trim(),error:'',key:key})
                })
            })
        },
        handleClickTab(val){
            if(val == this.activeTab){return false}
            this.activeTab = val
            if(val == 1){
                this.activeName = 1
            }else if(val == 2){
                if(this.$refs.textareaValue){
                    this.activeName = 2
                }else if(this.number && this.rule){
                    this.activeName = 4
                }else{
                    this.activeName = 3
                }
            }else if(val == 3){
                this.activeName = 5
            }
            if(this.oldActiveTab == val || val == 3){
                return  false
            }
            this.oldActiveTab = val
            this.textareaValue = ''
            this.number = null
            this.rule = ''
            this.codeData = []
            this.hasError = false

        },
        // 切换
        handleClickNav(val){
            this.activeName = val
            this.textareaValue = ''
            this.number = null
            this.rule = ''
            this.codeData = []
            this.hasError = false
        },
        // 清除
        handleClickDel(){
            this.textareaValue = ''
            this.codeData = []
            this.hasError = false
        },
        // 清除已选编码
        handleClickDelSelectedCode(item,key){
            this.product_code_list.splice(key,1)
        },
        // 删除编码
        handleClickDelCode(item){
            this.codeData.splice(item.key,1)
            this.codeData.forEach((list,index) => {
                list.key = index
            })
            if(this.codeData.length == 0){
                this.textareaValue = ''
                this.codeData = []
                this.hasError = false
            }
        },
        handleInputText(item){
            var duplicates = this.codeData.filter(filte => filte.value === item.value);
            if(this.validateCodeInput(item.value) == false){
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(item.value === '') {
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(duplicates.length>1){
                item.error = '输入的编码内容重复'
            }else if(this.selectedCodeData.find(find => find == item.value)){
                item.error = '输入的编码已选'
            }else{
                item.error =  '';
            }
            this.codeData.forEach((item,key)=>{
                this.handleInput(item)
            })
        },

        validateCodeInput(value) {
            const regex = /^[a-zA-Z0-9\-/（）.~_<>\s]+$/;
            if (regex.test(value)) {
                return true;
            }
            // 如果都不符合，则返回 false
            return false;
        },
        handleInput(item){
            var duplicates = this.codeData.filter(filte => filte.value === item.value);
            if(this.validateCodeInput(item.value) == false){
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(item.value === '') {
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”';
            }else if(this.selectedCodeData.find(find => find == item.value)){
                item.error = '输入的编码已选'
            }else if(duplicates.length>1){
                item.error = '输入的编码内容重复'
            }else{
                item.error =  '';
            }
        },

        handleClickConfirm() {
            if(this.hasError == false){
                if(this.activeName == 1 || this.activeName == 2){
                    var textArea = this.$refs.textareaValue
                    var lines = textArea.value.split('\n');
                    lines = lines.filter(Boolean);
                    this.codeData = []
                    lines.forEach((item,key)=>{
                        this.codeData.push({value:item.trim(),error:'',key:key})
                    })
                }
            }

            this.codeData.forEach((item,key)=>{
                this.handleInput(item)
            })
            const hasError = this.codeData.some(item => item.error !== '');
            this.hasError = hasError
            if(hasError){
                return false
            }
            if(this.activeName == 1 || this.activeName == 2){
                this.textareaValue = this.codeData.map(item => item.value).join('\n')
            }



            let code_type = this.activeTab == 1 ? 'encoding_detection' : 'manual_entry_binding'
            this.BtnDisabled = true
            if(this.codeData.length > 0){
                console.log(this.productInfo);
                if(this.productInfo && this.productInfo.name){
                    if(this.maxCodeIdentification != null){
                        if(this.codeData.length > this.maxCodeIdentification){
                            this.BtnDisabled = false
                            return  this.$toast('该产品入库数量/产品编码合计不可超过待入库数量，最多可输入'+this.maxCodeIdentification+'个')
                        }
                    }
                    let postData = {
                        product_name: this.productInfo?this.productInfo.name : null,
                        sku_id:  this.productInfo?this.productInfo.sku_id : null,
                        sku_key:  this.productInfo?this.productInfo.sku_key : null,
                        type: code_type,
                        code_list: this.codeData.map(item => item.value),
                        related_detail_id:0,
                        source_type:this.sourceType
                    }
                    if(this.related_info && this.related_info.stock_pending_id){
                        postData.stock_pending_id = this.related_info.stock_pending_id
                        postData.related_type = this.related_info.related_type
                        postData.related_id = this.related_info.related_id
                    }
                    if(this.productInfo && this.productInfo.related_detail_id){
                        postData.related_detail_id = this.productInfo.related_detail_id
                    }
                    codeCheck(postData).then(res => {
                        if(res.code == 200){
                            let { not_found_code, unmatched_code,err_code} = res.data
                            this.codeData.forEach((item,key)=>{
                                let find = err_code.find(find => find.code == item.value)
                                if(find && find.code){
                                    this.hasError = true
                                    item.error = find.err_msg
                                }
                            })
                            this.BtnDisabled = false
                            if(this.hasError == true){
                                return false
                            }
                            let code_list = []
                            this.codeData.forEach(item=>{code_list.push(item.value)})
                            let data = {
                                type: code_type,
                                code_list:code_list,
                                selected_code_list : this.product_code_list, //上一次的编码
                                not_found_code : not_found_code, // 不存在的编码
                                unmatched_code : unmatched_code, //已存在未绑定的编码
                            }
                            this.$emit("success", data)
                            this.$emit("update:codeIdentificationPopupShow", false)
                        }
                        this.loading = false
                    })
                }else{
                    if(this.sourceType == 'out'){
                        let postData = {
                            code_list: this.codeData.map(item => item.value)
                        }
                        if(this.related_info && this.related_info.stock_pending_id){
                            postData.stock_pending_id = this.related_info.stock_pending_id
                            postData.related_type = this.related_info.related_type
                            postData.related_id = this.related_info.related_id
                        }
                        identifyCodeOut(postData).then(res => {
                            if(res.code == 200){
                                let {true_code,err_code} = res.data
                                this.codeData.forEach((item,key)=>{
                                    let find = err_code.find(find => find.code == item.value)
                                    if(find && find.code){
                                        this.hasError = true
                                        item.error = find.err_msg
                                    }
                                })
                                this.BtnDisabled = false
                                if(this.hasError == true){
                                    return false
                                }
                                let code_list = []
                                this.codeData.forEach(item=>{code_list.push(item.value)})
                                let data = {
                                    type: code_type,
                                    code_list:code_list,
                                }
                                this.$emit("success", data)
                                this.$emit("update:codeIdentificationPopupShow", false)
                            }else{
                                this.BtnDisabled = false
                            }
                            this.loading = false
                        })
                    }else if(this.sourceType == 'in'){
                        let postData = {
                            code_list: this.codeData.map(item => item.value)
                        }
                        if(this.related_info && this.related_info.stock_pending_id){
                            postData.stock_pending_id = this.related_info.stock_pending_id
                            postData.related_type = this.related_info.related_type
                            postData.related_id = this.related_info.related_id
                        }
                        identifyCodeIn(postData).then(res => {
                            if(res.code == 200){
                                let {true_code,err_code} = res.data
                                this.codeData.forEach((item,key)=>{
                                    let find = err_code.find(find => find.code == item.value)
                                    if(find && find.code){
                                        this.hasError = true
                                        item.error = find.err_msg
                                    }
                                })
                                this.BtnDisabled = false
                                if(this.hasError == true){
                                    return false
                                }
                                let code_list = []
                                this.codeData.forEach(item=>{code_list.push(item.value)})
                                let data = {
                                    type: code_type,
                                    code_list:code_list,
                                }
                                this.$emit("success", data)
                                this.$emit("update:codeIdentificationPopupShow", false)
                            }else{
                                this.BtnDisabled = false
                            }
                            this.loading = false
                        })
                    }

                }

            }else{
                if(this.activeNameList.indexOf(5) < 0 &&  this.product_code_list.length == 0){
                    this.BtnDisabled = false
                    this.$toast('请输入产品编码')
                    return false
                }
                let data = {
                    type: code_type,
                    code_list:[],
                    selected_code_list : this.product_code_list, //上一次的编码
                    not_found_code : [], // 不存在的编码
                    unmatched_code : [], //已存在未绑定的编码
                }
                this.$emit("success", data)
                this.$emit("update:codeIdentificationPopupShow", false)
            }
        },
        handleClickClose(){
            this.$emit("update:codeIdentificationPopupShow", false)
        },

    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.code_identification_wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    .code_identification_top{
        width: 100%;
        border-bottom: 10px solid rgba(247, 248, 250, 1);
        box-sizing: border-box;
    }
    .code_identification_tab{
        height: 44px;
        overflow-x: auto;
        overflow-y: hidden;
        &::-webkit-scrollbar{
            height: 0px;
        }
        .code_identification_tab_wrap{
            width: max-content;
            display: flex;
            padding: 0 16px;
            box-sizing: border-box;
            span{
                padding: 0 16px;
                color: rgba(102, 102, 102, 1);
                line-height: 44px;
                position: relative;
                display: block;
                &.active{
                    color: rgba(41, 144, 255, 1);
                    font-weight: bold;
                    &::after{
                        content: ' ';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 2px;
                        background-color: rgba(41, 144, 240, 1);
                        border-top-left-radius: 1px;
                        border-top-right-radius: 1px;
                    }
                }
            }
        }
    }
    .code_identification_nav{
        width: 100%;

        overflow-x: auto;
        &::-webkit-scrollbar{
            height: 0px;
        }
        .code_identification_nav_wrap{
            width: max-content;
            display: flex;
            padding: 0 16px;
            box-sizing: border-box;
            span{
                border-radius: 4px;
                line-height: 26px;
                padding: 0 12px;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
                display: block;
                margin: 9px 0;
                &.active{
                    color: rgba(41, 144, 255, 1);
                    background: rgba(41, 144, 255, 0.16);
                }
            }
        }


    }


    .code_identification_content{
        flex: 1;
        padding: 12px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        &.code_identification_content_wrap{
            height: calc(100% - 212px);
        }
        .top{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 4px;
            div.title{
                color: rgba(51, 51, 51, 1);
                font-size: 14px;
                line-height: 22px;
                &.required{
                    padding-left: 8px;
                    position: relative;
                    &:before{
                        content: '*';
                        color: rgba(228, 65, 68, 1);
                        position: absolute;
                        left: 0;
                        top: 0;
                        font-size: 14px;
                    }
                }
            }
            div.num{
                line-height: 22px;
                font-size: 14px;
                color: rgba(153, 153, 153, 1);
                span{
                    color: rgba(51, 51, 51, 1);
                }
                span.del{
                    color: rgba(228, 65, 68, 1);
                    margin-left: 8px;
                    cursor: pointer;
                    &:hover{
                        color: rgba(233, 103, 105, 1);
                    }
                    &:active{
                        color: rgba(182, 52, 54, 1);
                    }
                }
            }
        }
        .bottom{
            width: 100%;
            flex: 1;
            overflow: hidden;
            .height_flex{
                height: 100%;
                ::v-deep .el-textarea__inner{
                    height: 100%;
                }
            }
            .error_code_wrap{
                width: 100%;
                overflow-y: auto;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1) !important;
                border: 1px solid rgba(217, 217, 217, 1);
                padding: 0 !important;
                box-sizing: border-box;
                ul{
                    width: 100%;
                    padding: 8px 4px;
                    box-sizing: border-box;
                    li{
                        width: 100%;
                        margin-bottom: 8px;
                        .code_input{
                            width: 100%;
                            position: relative;
                            .el-icon-error{
                                position: absolute;
                                right: 8px;
                                top: 7px;
                                font-size: 16px;
                                color: rgba(191, 191, 191, 1);
                                cursor: pointer;
                                display: none;
                            }
                            .el-icon-error{display: block}
                            ::v-deep .el-input__inner{
                                border: 0;
                                height: 30px;
                                line-height: 30px;
                                padding: 0 38px 0 8px;
                                background: rgba(0, 0, 0, 0.04);
                            }
                            &.error  ::v-deep .el-input__inner{
                                color: rgba(228, 65, 68, 1);
                            }
                        }
                        p{
                            line-height: 18px;
                            font-size: 12px;
                            color: rgba(228, 65, 68, 1);
                            padding-left: 8px;
                            box-sizing: border-box;
                        }
                    }
                }
            }
            .set_generate_code_wrap{
                overflow-y: auto;
                border-radius: 4px;
                background: rgba(247, 248, 250, 1);
                border: 1px solid rgba(232, 232, 232, 1);
                padding: 12px;
                box-sizing: border-box;
                p{
                    font-size: 14px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 22px;
                }
                ul{
                    li{
                        color: rgba(102, 102, 102, 1);
                        line-height: 22px;
                        font-size: 14px;
                    }
                }
            }
        }
        .set_generate_code_input{
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            padding-bottom: 4px;
            position: relative;
            &::before{
                width: calc(100% + 32px);
                height: 1px ;
                content:  ' ';
                background: rgba(247, 248, 250, 1);
                position: absolute;
                left: -16px;
                bottom: 0;
                z-index: 8;
            }
            .van-cell{
                padding: 0 !important;
                line-height: 32px;
                ::v-deep .van-field__label{
                    line-height: 32px;
                    padding-left: 8px;
                    box-sizing: border-box;
                    color: rgba(51, 51, 51, 1);

                }

            }
            ::v-deep .van-cell--required::before{
                left: 0px !important;
            }
            &.borderRadio{
                margin-bottom: 0px;
                padding: 6px 0;
                .el-input{
                    min-width: 244px;
                    ::v-deep .el-input__inner{

                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                }
                .el-input-number{
                    width: 100%;
                    ::v-deep .el-input__inner{
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                    }
                }
            }

            .el-input-number{
                width: 100%;
                ::v-deep .el-input__inner{
                    text-align: left;
                }
            }
            .el-button{
                margin-left: 8px;
            }
        }
        .prompt{
            font-size: 12px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 16px;
        }
    }
    .code_identification_footer {
        padding:16px;
        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}

</style>